module.exports = __webpack_public_path__ + "img/3.811ab5b2.png";